import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';

import Loading from '../../loading';
import ColumnChart from './recharts';
import { styles } from './styles';
import Toolbar from './toolbar.js';

const month = 2;
class Dashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            date: ''
        }
        this.date = ''; 
        this.setData = this.setData.bind(this)
    }
    
    componentDidMount() {
        let end = moment().endOf('month').format('YYYY-MM-DD');
        
        let intervalMonth = month;        
        let monthBegin = moment().subtract(intervalMonth, 'months').month()+1;
        let yearBegin = moment().subtract(intervalMonth, 'month').year();

        let begin =  moment([yearBegin, monthBegin - 1]).format('YYYY-MM-DD');
        this.getReationCount(begin, end)
    }
    getReationCount = async(begin,end) => {
        this.loading.startLoading()
        await this.props.userServicesDispatch.getReationCount({begin, end})
        this.loading.stopLoading()
    }
    fetchData = (date)=> {
        date = moment(date);
        let end = new Date(date.year(),date.month() + 1, 0);
        let intervalMonth = month;
        let monthBegin = date.subtract(intervalMonth, 'months').month()+1;
        let yearBegin = date.subtract(intervalMonth, 'month').year();
        
        let begin = new Date(yearBegin , monthBegin);
        this.date = end;
        this.getReationCount(begin, end)
    }
    calculationReation(countReaction, data, key, month) {
        for(let i = 0; i < countReaction.length; i++) {
            let obj = countReaction[i];
            for(let j=2 ; j > -1 ; j--) {
               if (obj.month === month[j]) {
                    data[j][key] =  obj.count;
                }
            }
        }
        return data;
    }
    setData(countReaction) {

        let month = [], data = [], monthCount, yearCount;

        for(let i = 2 ; i >= 0 ; i--)  // i la so thang hien thi
        { 
            if(this.date) {
                monthCount = moment(new Date(this.date)).subtract(i, 'months').month()+1;
                yearCount =  moment(new Date(this.date)).subtract(i, 'months').year();
            }
            else {
                monthCount = moment(new Date()).subtract(i, 'months').month()+1;
                yearCount =  moment(new Date()).subtract(i, 'months').year();
            }
            month.push(monthCount)
            data.push({
                name: moment(monthCount+'-'+yearCount, 'MM-YYYY').format('MM-YYYY'),
                Like: 0,
                Heart: 0,
                Follow: 0,
            })
        }
        data = this.calculationReation(countReaction.like,data, "Like", month)
        data = this.calculationReation(countReaction.heart,data, 'Heart', month)
        data = this.calculationReation(countReaction.follow,data, 'Follow', month)
        return data;
    }
    render() { 
        const { classes, t } = this.props;
        const countReaction = this.props.userServicesState.countReaction;
        const data = countReaction.like ? this.setData(countReaction) : []; 
        let countLike = 0, countHeart = 0, countFollow = 0;
        countReaction.like.forEach(like => {
            countLike += like.count;
        })
        countReaction.heart.forEach(heart => {
            countHeart += heart.count;
        })
        countReaction.follow.forEach(follow => {
            countFollow += follow.count;
        })
        
        return (
            <div style={{width: '100%'}}>
                <Paper className={classes.root}>
                    <Loading onRef={id => (this.loading = id)}/>
                    <Toolbar fetchData={this.fetchData} />
                    <div className={classes.container} >
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={4} className = {classes.leftReaction}>
                                <Typography variant="h6" className={classes.labelChart}>{t('dashboard_reaction_like')}</Typography>
                                <div className={classNames(classes.countReact,classes.countReactLike)}>
                                    {countLike}
                                </div>
                                <Typography variant="h6" className={classes.labelChart}>{t('dashboard_reaction_heart')}</Typography>
                                <div className={classNames(classes.countReact,classes.countReactHeart)}>
                                    {countHeart}
                                </div>
                                <Typography variant="h6" className={classes.labelChart}>{t('dashboard_reaction_follow')}</Typography>
                                <div className= {classNames(classes.countReact, classes.countReactFollow)}>
                                    {countFollow}
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={8} className = {classes.rightReaction}>
                                <ColumnChart countReaction={data}/>
                            </Grid>
                        </Grid>
                    </div>
                </Paper>
            </div>
        );
    }
}

Dashboard.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};
const mapState = state => ({
    userServicesState: state.userServices
});

const mapDispatch = dispatch => ({
    userServicesDispatch: dispatch.userServices
});


export default connect(mapState, mapDispatch)(translate('translations')(withStyles(styles, { withTheme: true })(Dashboard)));